import Alert from './Alert'

export default class ErrorAlert extends Alert{
    constructor() {
        super({});
    }

    show() {
        swal({
            title: 'Oops',
            text: uLang('app.something_bad_happened'),
            icon: 'error',
            confirmButtonClass: 'btn btn-done',
            cancelButtonClass: 'btn btn-danger',
            button: this.key('button', uLang('app.close')),
            closeOnClickOutside: false,
            closeOnEsc: false,
        })
    }
}
